import fetchNspData from './fetch-nsp-data';

export default async function fetchAllRoutes() {
  const res = await fetchNspData({ model: 'routes' });
  return res.allRoutes;
}
